import { useEffect, useState } from 'react';
import { Lock, Loader2, CheckCircle2 } from 'lucide-react';
import { toast } from 'sonner';
import { api } from '@/api/client';

export function ResetPasswordPage() {
  const [token, setToken] = useState('');
  const [pwd, setPwd] = useState('');
  const [confirm, setConfirm] = useState('');
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    const p = new URLSearchParams(window.location.search);
    setToken(p.get('token') ?? '');
  }, []);

  const submit = async () => {
    if (!token) return toast.error('Missing reset token (open the link from the email)');
    if (pwd.length < 6) return toast.error('Password must be at least 6 characters');
    if (pwd !== confirm) return toast.error('Passwords do not match');
    setBusy(true);
    try {
      await api.post('/auth/reset-password-v2', { token, newPassword: pwd });
      setDone(true);
      toast.success('Password updated');
    } catch (e: any) {
      toast.error(e?.response?.data?.message ?? 'Reset failed');
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-sm border border-slate-200 p-6">
        <div className="flex items-center gap-2 mb-4">
          <div className="bg-primary/10 text-primary p-2 rounded-lg"><Lock size={18} /></div>
          <h1 className="text-xl font-bold text-slate-900">Set a new password</h1>
        </div>
        {done ? (
          <>
            <div className="flex items-center gap-2 text-emerald-700 mb-3"><CheckCircle2 size={18} /> Password updated.</div>
            <a href="/login" className="block text-center bg-primary text-white py-2.5 rounded-lg font-medium hover:bg-primary-700">Sign in</a>
          </>
        ) : (
          <>
            <label className="text-xs font-medium text-slate-700">New password</label>
            <input type="password" value={pwd} onChange={(e) => setPwd(e.target.value)}
              className="w-full mt-1 mb-3 px-3 py-2 border border-slate-300 rounded-lg outline-none focus:border-primary" />
            <label className="text-xs font-medium text-slate-700">Confirm new password</label>
            <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && submit()}
              className="w-full mt-1 mb-4 px-3 py-2 border border-slate-300 rounded-lg outline-none focus:border-primary" />
            <button onClick={submit} disabled={busy || !pwd || !confirm}
              className="w-full bg-primary text-white py-2.5 rounded-lg font-medium hover:bg-primary-700 disabled:opacity-60 flex items-center justify-center gap-2">
              {busy ? <Loader2 size={16} className="animate-spin" /> : null}
              Update password
            </button>
          </>
        )}
      </div>
    </div>
  );
}
